import { DeviceTypeDetails } from 'modules/devices/domain/api/device-type.api';
import { createContext } from 'react';

export type DeviceTypesContextType = {
    deviceTypes: DeviceTypeDetails[];
    isLoading?: boolean;
    setDeviceTypes: (deviceTypes: DeviceTypeDetails[]) => void;
};

export const DeviceTypesContext = createContext<DeviceTypesContextType | undefined>(undefined);
